var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 137 137"
    },
    xmlSpace: "preserve",
    viewBox: "27.25 27.13 83.12 82.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stWhitePen{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hintergrund"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stWhitePen",
    d: "M58.6,97.2L40.4,78.9l46.7-46.7c1.9-1.9,5-1.9,6.8,0l11.4,11.4c1.9,1.9,1.9,5,0,6.8L58.6,97.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "stWhitePen",
    x1: 79.1,
    y1: 40.9,
    x2: 96.6,
    y2: 58.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "stWhitePen",
    x1: 71.5,
    y1: 48.5,
    x2: 89,
    y2: 66
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "stWhitePen",
    points: "40.4,78.9 30.9,105.5 58.6,97.2   "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPen);
export default __webpack_public_path__ + "static/media/Icon_Pen.fdb25d6fa59230fc5b929d2d3eba048b.svg";
export { ForwardRef as ReactComponent };